module.exports = __webpack_public_path__ + "media/images/no-result-1-729a27bbcd296a80867dc5dd1d73690f.jpg";